import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog,MatCheckboxChange} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { TechnologyoverlayService } from '../../../technologyoverlay.service';
import { getDeviceDetailsReq, getSpaceCategory, duplicateSpace} from '../../../technologyoverlay';
import { takeUntil } from 'rxjs/operators';
import { SessionCheck, generateAlertMessage, AuthFailedMessage } from '../../../../../app-general';
import {Router} from '@angular/router';
import { ApiService } from '../../../../../api.service';
import { enumSpaceCategory,NewDeviceTypeDesc,DeviceType,appsettings } from '../../../../../app-settings';

@Component({
  selector: 'app-duplicate-unit',
  templateUrl: './duplicate-unit.component.html',
  styleUrls: ['./duplicate-unit.component.scss']
})
export class DuplicateUnitComponent implements OnInit {
  
  public unitDuplicateForm : FormGroup;
  selectedUnitId;
  FloorInfo;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  SpaceInfo;
  watcher: Subscription;
  columns = 4;
  firstcolumns = 2;
  minheight = "350px"; 
  rowHeight = "79px";
  checkfloorinfo = false;
  select_DeviceIds = [];
  DevicesInfo;
  selectedFloorName;
  selectFloorId;
  DevicesInfowithoutZone = [];
  isCheckedAll = false;
  checkResOffLimits = false;
  Spacecategory_details;
  selectCategoryId;
  duplicatecheckSpaceCategory = 0;
  selectCampusId;
  
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<DuplicateUnitComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService,public dialog: MatDialog,private apiService: ApiService) { 
    
    this.selectedUnitId = data.UnitId;
    this.selectedFloorName = data.FloorName;
    this.selectFloorId = data.FloorId;  
    this.selectCampusId = data.CampusId;      
    if(data.SpaceCategoryId > 0)
    {
      this.selectCategoryId = data.SpaceCategoryId;
      if(this.selectCategoryId == enumSpaceCategory.StaffArea || this.selectCategoryId == enumSpaceCategory.ActivityArea || 
         this.selectCategoryId == enumSpaceCategory.DiningArea || this.selectCategoryId == enumSpaceCategory.CommonArea)
      {
        this.duplicatecheckSpaceCategory = 1;
      }                   
    }
    
    if(data.isResidentOffLimit == 1)
      this.checkResOffLimits = true;
    else
      this.checkResOffLimits = false;
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {
          this.columns = 2;  
          this.firstcolumns = 1;                  
          this.minheight = "auto";
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 2;
          this.firstcolumns = 2;     
          this.minheight = "auto";
        }  
        else if (change.mqAlias == 'md') {
          this.columns = 2;  
          this.firstcolumns = 1; 
          this.minheight = "350px";               
        }               
       else
       {
         this.columns = 4;  
         this.firstcolumns = 2;      
         this.minheight = "350px";               
       }
      }
    
    });
  }

  ngOnInit() {
    this.unitDuplicateForm = new FormGroup({
      unitName: new FormControl(''),    
      campusID: new FormControl(''), 
      buildID: new FormControl(''), 
      floorID: new FormControl(''), 
      UnitID: new FormControl(''),      
      newunitname:new FormControl('', [Validators.required, Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
      description: new FormControl('', [Validators.pattern(appsettings.Name_Pattern)]),
      roomcategory: new FormControl('',[Validators.required]),
    });
    
    this.unitDuplicateForm.get('unitName').disable();    
    
    this.isCheckedAll = true;
    this.getDeviceDetails();
    this.getSpaceCategory();        
  }
  
  getDeviceDetails()
  {
    try
    {
      let voiceLicense = localStorage.getItem("voice_license");
      var devicedata:getDeviceDetailsReq = 
      { siteId: this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        campusId:this.selectCampusId,
        floorId: parseInt(this.selectFloorId),
        status:  "3",
        devicetype: 0,
        device: 0, 
        spaceId: parseInt(this.selectedUnitId),
        isIndoor:1,
        isNeedRoomonly:1,
        isNeedIntercom:parseInt(voiceLicense)
       };
      
        this.apiService.getDeviceDetails(devicedata).pipe(takeUntil(this._onDestroy))
          .subscribe((DeviceDetails: any[]) => {
        
        this.DevicesInfo = DeviceDetails["apiReturn"];    
        var Device_infos = [];
        DeviceDetails["apiReturn"].forEach(function(data)
        {        
          if(data.FilterDeviceType != NewDeviceTypeDesc.Zone)
          {
            Device_infos.push(data);
          }
          if(data.FilterDeviceType == NewDeviceTypeDesc.LF)
          {
            if (data.SubType==DeviceType.DripTray)
            {
              data.FilterDeviceType =NewDeviceTypeDesc.DripTray
            }
            else
            {
             data.FilterDeviceType =NewDeviceTypeDesc.LFExiter
            }
          }
        })
        this.DevicesInfowithoutZone = Device_infos;      
        this.toggleAll(this.isCheckedAll)
      });
    }
    catch (err) {
      throw new Error('duplicate-unit.component.ts' + ' - getDeviceDetails() - ' + err.message);
    }
  }
  
getSpaceCategory()
{
  try
  {    
    var spaceitem : getSpaceCategory = 
    {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"), 
      categoryId: 0
    }
    this.technologyoverlayService.getSpaceCategory(spaceitem).pipe(takeUntil(this._onDestroy))
    .subscribe((spacedetails: any[]) => {
      this.Spacecategory_details = spacedetails;                            
    });
  }
  catch (err) {
    throw new Error('duplicate-unit.component.ts' + ' - getSpaceCategory() - ' + err.message);
  }
}
  
  public onCloseCancel = () => 
  { 
    this.thisDialogRef.close('close');  
    if(!SessionCheck(this.router))
    {
        return;
    }         
         
  }
  
  toggleAll(event: any) {
    console.log(event)
    if (event.checked || event == true) {
      this.select_DeviceIds = [];      
      this.DevicesInfo.forEach(row => {
      
        if(row.FilterDeviceType != NewDeviceTypeDesc.Zone)
        {
          var checkedid = row.DataId
          this.select_DeviceIds.push(checkedid)
        }
      });
      
    } else {
      
      this.select_DeviceIds = [];
      this.select_DeviceIds.length = 0;
    }
    this.isCheckedAll = this.isChecked();
  }



toggledeviceVisibility(checkedid, event: MatCheckboxChange) {
  if (event.checked) {
    const index = this.select_DeviceIds.indexOf(checkedid);
    if (index == -1) {
      this.select_DeviceIds.push(checkedid);
    }
  } else {
    const index = this.select_DeviceIds.indexOf(checkedid);
    if (index >= 0) {
      this.select_DeviceIds.splice(index, 1);
    }
  }
  this.isCheckedAll = this.isChecked();
  
}

exists(checkedid) {
  return this.select_DeviceIds.indexOf(checkedid) > -1;
};

isChecked() {
  return this.select_DeviceIds.length === this.DevicesInfowithoutZone.length;
};
handleInput(event) 
{
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.unitDuplicateForm.controls).forEach(field => { // {1}
        const control = this.unitDuplicateForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('duplicate-floor.component.ts' + ' - handleInput() - ' + err.message);
    }
}

selectSpaceCategory(categoryId)
{       
  this.selectCategoryId = categoryId;         
} 

public duplicateunitDetails = (duplicateunitformvalue) => 
  {
    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      (document.activeElement as HTMLTextAreaElement).blur(); 
      if (this.unitDuplicateForm.valid) { 
        let saveclick = document.getElementById('btnspaceduplicatesaveclick');
            saveclick.className = 'clsunitdupsavebutton mat-raised-button disablebtn';
          this.duplicateSpace(duplicateunitformvalue)
      }
    }
    catch(err)
    {
      throw new Error('template-floor.component.ts' + ' - templatefloorDetails() - ' + err.message);
    }
  }
  
  duplicateSpace(duplicateunitformvalue)
  {
    try
    {
      var resofflimits = 0;
      let saveclick = document.getElementById('btnspaceduplicatesaveclick');
      if (this.select_DeviceIds.length==0 && this.DevicesInfo.length>0)
      {
        generateAlertMessage(this.dialog, 'Must add at least one Device to create as a new Space.');   
        saveclick.className = 'clsunitdupsavebutton mat-raised-button';
        return;
      }
      if (this.select_DeviceIds.length==0 && this.DevicesInfo.length==0)
      {
        generateAlertMessage(this.dialog, 'Must add at least one Device to duplicate or create as a Template.');      
        saveclick.className = 'clsunitdupsavebutton mat-raised-button';
        return;
      }      
      saveclick.className = 'clsunitdupsavebutton mat-raised-button disablebtn';
      
      let _Description = "";        
        if(duplicateunitformvalue.description != "")
          _Description = duplicateunitformvalue.description.replace(/\s+/g, ' ').trim();
        else
          _Description = "";
          
        if(this.checkResOffLimits == true)
          resofflimits = 1;
        else
          resofflimits = 0;                 
      
      let duplicateSpaceinfo: duplicateSpace = {
        siteId:this.SiteId,
        authKey:localStorage.getItem("Authkey"),
        campusId:parseInt(duplicateunitformvalue.campusID),
        buildingId:parseInt(duplicateunitformvalue.buildID),
        zoneId:parseInt(duplicateunitformvalue.floorID),
        spaceId:parseInt(duplicateunitformvalue.UnitID),
        newSpaceName:duplicateunitformvalue.newunitname.replace(/\s+/g, ' ').trim(),
        newSpaceDescription:_Description,//duplicateunitformvalue.description,
        deviceIds:this.select_DeviceIds.toString(),
        residentOffLimits:resofflimits,
        spaceCategoryId:parseInt(this.selectCategoryId),
      }      
      this.technologyoverlayService.duplicateSpace(duplicateSpaceinfo).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse: any[]) => 
      { 
        
          if(apiresponse['NewSpaceId'] > 0)
          {
            generateAlertMessage(this.dialog, 'Duplicate Space added successfully.'); 
            saveclick.className = 'clsunitdupsavebutton mat-raised-button';      
            this.thisDialogRef.close(apiresponse); 
            this.select_DeviceIds = [];
          }
          else if(apiresponse.toString() == "false")
          {
            generateAlertMessage(this.dialog, 'Duplicate Space added failed.'); 
            saveclick.className = 'clsunitdupsavebutton mat-raised-button';      
            this.thisDialogRef.close("close"); 
            this.select_DeviceIds = [];
          }
          else if(apiresponse["condition"] == "Authfalse")
          {    
              this.thisDialogRef.close('Cancel');              
              AuthFailedMessage(this.dialog,this.router);  
              return;       
          }
          else if(apiresponse["condition"] == "Duplicate Gateway")
          {    
            generateAlertMessage(this.dialog, 'Clear Gateway already added.Please select any other devices'); 
            saveclick.className = 'clsunitdupsavebutton mat-raised-button';      
            return;      
          }
          else if(apiresponse["condition"] == "Duplicate Clear Router")
          {    
            generateAlertMessage(this.dialog, 'Clear Router already added.Please select any other devices'); 
            saveclick.className = 'clsunitdupsavebutton mat-raised-button';      
            return;     
          }
          else
          {            
            generateAlertMessage(this.dialog, "Space name '" + apiresponse[0].UnitName + "' already exists.");              
            saveclick.className = 'clsunitdupsavebutton mat-raised-button';
            return; 
          }
      })
    }    
    catch(err)
    {
      throw new Error('duplicate-unit.component.ts' + ' - duplicateSpace() - ' + err.message);
    }
  }
  
  toggler_ResOffLimits(e) {
    if (e.checked == true) {
      this.checkResOffLimits=true;
    }
    else{
      this.checkResOffLimits=false;
    }
  }

}
